import React from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import useWindowSize from '../../../../hooks/useWindowSize';
// import NavSearch from './NavSearch';

const NavLeft = () => {
    const windowSize = useWindowSize();

    let dropdownRightAlign = false;

    let navItemClass = ['nav-item'];
    if (windowSize.width <= 575) {
        navItemClass = [...navItemClass, 'd-none'];
    }

    const hardRefresh = (event) => {
        document.location.reload(true);
    }

    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto" style={{ backgroundColor: '#f4c22b' }}>
                <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')}>
                    <Dropdown alignRight={dropdownRightAlign}>
                        <Dropdown.Toggle variant={'link'} id="dropdown-basic">
                            Actions
                        </Dropdown.Toggle>
                        <ul>
                            <Dropdown.Menu>
                                <li>
                                    <Link to="#" onClick={(e) => hardRefresh(e)} className="dropdown-item">
                                        Actualiser la page
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/" target={"_blank"} className="dropdown-item">
                                        Ouvrir un nouvel onglet
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/" target="_blank" className="dropdown-item">
                                        Ouvrir une nouvelle fenêtre
                                    </Link>
                                </li>
                            </Dropdown.Menu>
                        </ul>
                    </Dropdown>
                </ListGroup.Item>
                {/* <ListGroup.Item as="li" bsPrefix=" " className="nav-item">
                    <NavSearch windowWidth={windowSize.width} />
                </ListGroup.Item> */}
            </ListGroup>
        </React.Fragment>
    );
};

export default NavLeft;
